import usePageMetadata from "./usePageMetadata";

const useIsRoleAdmin = () => {
  const { localDB } = usePageMetadata();
  const role_key = `${localDB.name}_role`;
  const admin_flag_key = `${localDB.name}_is_admin`;
  const storedAdminFlag = localStorage.getItem(admin_flag_key);
  if (storedAdminFlag !== null) {
    return storedAdminFlag === "true";
  }

  const role = localStorage.getItem(role_key);
  return role === "global_admin";
};

export default useIsRoleAdmin;
